<div>
    <div class="loading-gif">
        <img src="assets/images/loading/kiosk-upgrading.gif" style="width: 500px; height: auto;">
    </div>
    <p style="padding-top: 15px;">{{headerText}}</p>
</div>
